export const ConvertErrorArrayToString = (errors) => {
	let returnHtml = '';
	let errorsArray = Object.values(errors);
	if (errorsArray.length > 0) {
		errorsArray.forEach((item) => {
			returnHtml += `${item} <br />`
		})
	}
	return returnHtml;
}

export const integerTest = (value) => { return /^-?\d+$/.test(value) };

export const hifz_status_list = [
	'Surah an-Nas',
	'Surah al-Falaq',
	'Surah al-Ikhlas',
	'Surah al-Masad',
	'Surah an-Nasr',
	'Surah al-Kafirun',
	'Surah al-Kauthar',
	'Surah al-Maun',
	'Surah Quraish',
	'Surah al-Fil',
	'Surah al-Humazah',
	'Surah al-Asr',
	'Surah at-Takathur',
	'Surah al-Qariah',
	'Surah al-Adiyat',
	'Surah az-Zalzalah',
	'Surah al-Bayinah',
	'Surah al-Qadar',
	'Surah al-Alaq',
	'Surah at-Tin',
	'Surah ash-Sharah',
	'Surah ad-Duha',
	'Surah al-Lail',
	'Surah ash-Shams',
	'Surah al-Balad',
	'Surah al-Inshiqaq',
	'Juz Amma',
	'Sanah Ula',
	'Sanah Saniyah',
	'Sanah Salesah',
	'Shahadat Hifz al-Quran'
];
export const intl_posts = [
	{
		id: 'sr_asst_cmd',
		value: 'Sr. Assitant Commander'
	}, {
		id: 'asst_cmd',
		value: 'Assitant Commander',
	},
	{
		id: 'major',
		value: 'Major',
	}, {
		id: 'hr_admin',
		value: 'HR Admin',
	}
	, {
		id: 'office_admin',
		value: 'Office Admin',
	}
];
export const local_posts = [
	{
		id: 'captain',
		value: 'Captain',
	}, {
		id: 'vice_captain',
		value: 'Vice Captain',
	},
	{

		id: 'grp_leader',
		value: 'Group Leader',
	}, {

		id: 'ass_grp_leader',
		value: 'Assistant Group Leader',
	},
	{

		id: 'div_admin',
		value: 'Division Admin',
	},
	{
		id: 'member',
		value: 'Member',
	}
]

export const getIntPost = (ntlPost) => {
	let returnVal = '';
	for (let ip of intl_posts) {
		if (ip.id === ntlPost) {
			returnVal = ip.value
			break;
		}
	}
	return returnVal;
}

export const getLocalPost = (loclPost) => {
	let returnVal = '';
	for (let ip of local_posts) {
		if (ip.id === loclPost) {
			returnVal = ip.value
			break;
		}
	}
	return returnVal;
}
export const transactions_type = {
	'yearly_fees': 'Yearly Fees',
	'jacket': 'Jacket',
	'uniform_with_accessories': 'Uniform with accessories',
	'uniform_with_shirt_accessories': 'Uniform with shirt accessories',
	'accessories': 'Accessories',
	'registration': 'Member Registration'
}
export const transactionTypesOptions = [
	{
		id: 'yearly_fees',
		value: 'Yearly Fees'
	},
	{
		id: 'jacket',
		value: 'Jacket'
	},
	{
		id: 'uniform_with_accessories',
		value: 'Uniform with accessories'
	},
	{
		id: 'uniform_with_shirt_accessories',
		value: 'Uniform with shirt accessories'
	},
	{
		id: 'accessories',
		value: 'Accessories'
	},
	{
		id: 'registration',
		value: 'Member Registration'
	},
]
export const MemberExportOptions = {
	"user_father_name": "Father Name",
	"user_sabeel_code": "Sabeel Code",
	"user_qualification": "Qualification",
	"user_email": "Email",
	"user_dob": "Date of Birth",
	"user_blood_group": "Blood Group",
	"user_address": "Address",
	"user_occupation": "Occupation",
	"user_work_address": "Work Address",
	"user_introduced_by": "Introduced By",
	"user_family_members": "Family Members",
	"user_father_occupation": "Father Occupation",
	"user_earning_members": "Earning Members",
	"user_hobby": "Hobby",
	"user_area_specialization": "Area Specialization",
	"user_join_reason": "Join Reason",
	"user_passport_name": "Passport Name",
	"user_passport_expiry": "Passport Expiry",
	"user_namaaz": "Namaaz",
	"user_quran_tilawat": "Quran Tilawat",
	"user_beard": "Beard",
	"user_majlis_attendance": "Majlis Attendance",
	"user_asbaq": "Asbaq",
	"user_moharramat": "Moharramat",
	"user_hifz": "Hifz",
	// "user_vaccinated": "Vaccinated",
	// "user_vaccine": "Vaccine",
	// "user_vaccine_first_dose": "Vaccine First Dose",
	// "user_vaccine_second_dose": "Vaccine Second Dose",
	// "user_vaccine_certificate_number": "Vaccine Certificate Number",
	"user_sector": "Sector",
}